import React from 'react';

import { Alert } from '@mui/material';

export default function LinkDealOptionsTab() {
  return <Alert severity="info">Coming soon.</Alert>;
}
